<template>
  <div
    style="min-width:80vw;min-height:90vh;position:absolute;top:5%;left:10%;z-index:9999;text-align: center;background-color: rgba(7,35,59,.9);border: 1px solid rgba(41, 155, 255, .5)"
    v-if="divVisible">
    <i @touchstart="divClose" @click="divClose" class="el-icon-close close-btn"></i>
    <!-- 弹窗标题-->
    <div style="margin:15px 0 10px 0;display: inline-block">
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(15, 61, 104, 1), rgba(41, 155, 255, 1));"></div>
      <div class="title"> {{ deviceInfo.name }}</div>
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(41, 155, 255, 1), rgba(15, 61, 104, 1));"></div>
    </div>
    <!-- 弹窗主体内容 -->
    <div style="height: 84vh;width: 80vw;display: flex;">
      <!-- 当前层区域内景图主体部分-->
      <el-main style="width: 100%;height: 100%;border: #0b3d68 5px double;position:relative;margin: 0 5px 0 5px">
        <!-- 左侧边栏-当前设备楼层树节点-->
        <div>
          <el-button icon="el-icon-caret-right" @touchstart="tierDrawer = true"  @click="tierDrawer = true"
                     style="position:absolute;height: 50px;width: 50px;font-size: 20px;left: 0;top: 45%;border-radius: 0 5px 5px 0"></el-button>
          <el-drawer
            :visible.sync="tierDrawer"
            :direction="tierDirection"
            :before-close="tierDrawerClose"
            :show-close="true"
            :modal="false"
            :wrapperClosable="false"
            :size="areaSize"
            style="width: 20%;position:absolute;">
            <div slot="title" style="font-weight: bolder;">{{ deviceInfo.name }}</div>
            <div class="tierDiv" v-for="(item,index) in tierList" :style="{'backgroundColor':item.backgroundColor}"
            @touchstart="tierClick(item)"  @click="tierClick(item)"
                 :key="index">
              <div style="width: 30%;display: flex;justify-content: flex-end">
                <span
                  style="width: 8px;height: 8px;background: #1AB71A;border-radius: 4px 4px 4px 4px;opacity: 1;display: inline-block;margin-right: 10px"
                  :style="{backgroundColor: item.status===0? '#1AB71A':'#E82E2D'}"></span>
              </div>
              <span style="width: 70%;display: flex;justify-content: flex-start">{{
                  item.cnName
                }}</span>
            </div>
          </el-drawer>
        </div>
        <!-- 区域内景图-->
        <el-main style="width: 100%;height: 100%">
          <firePanelMap v-show="indoorBg" :areaList="areaList" :indoorBg="indoorBg"></firePanelMap>
        </el-main>
        <!-- 右侧边栏-当前层告警列表-->
        <div class="asideRight">
          <el-button icon="el-icon-caret-left" @touchstart="areaAlarmDrawer = true"  @click="areaAlarmDrawer = true"
                     style="position:absolute;height: 50px;width: 50px;font-size: 20px;right: 0;top: 45%;border-radius: 5px 0 0 5px;padding: 0"></el-button>
          <el-drawer
            :visible.sync="areaAlarmDrawer"
            :direction="areaDirection"
            :before-close="areaDrawerClose"
            :show-close="true"
            :modal="false"
            :wrapperClosable="false"
            :size="areaSize"
            style="position:absolute;">
            <div slot="title" style="font-weight: bolder;">消防告警</div>
            <div style="height: 100%;width: 100%;">
              <div
                style="height: 100px;width: 100%;text-align: left;border-bottom: rgba(7,35,59) 2px solid;margin-bottom: 10px;padding-left: 15px;padding-right: 10px"
                v-for="(item,index) in areaAlarmList" :key="index">
                <div class="margin-bottom-10">{{ item.msg }}</div>
                <div style="color: #FFFFFF80">{{ item.modifyTime }}</div>
              </div>
            </div>
          </el-drawer>
        </div>
      </el-main>
    </div>
  </div>
</template>

<script>
import firePanelMap from "@/components/device_details/comp/firePanelMap";
import {getTierInfoByDeviceId} from "@/network/fire-alarm-panel-network";

export default {
  name: "fireAlarmControlPanel",
  props: ['divVisible', 'deviceInfo'],
  components: {
    firePanelMap
  },
  data() {
    return {
      // 弹窗是否展示
      visible: false,
      // 楼层抽屉是否展示
      tierDrawer: true,
      tierDirection: 'ltr',
      // 区域告警抽屉是否展示
      areaAlarmDrawer: true,
      areaDirection: 'rtl',
      areaSize: '100%',
      // 楼层列表
      tierList: [],
      // 区域列表
      areaList:[],
      // 区域告警列表
      areaAlarmList: [],
      // 内景图背景
      indoorBg:""
    }
  },
  mounted() {
    this.getTierInfoByDeviceId(this.deviceInfo.id).then(()=>{
      if(this.tierList!=null && this.tierList.length!=0){
        this.getAreasByTier(this.deviceInfo.id,this.tierList[0].ordinal).then(()=>{
          this.tierClick(this.tierList[0])
        })
      }
    });
  },
  methods: {
    // 根据消防主机设备id查询所有楼层信息
    async getTierInfoByDeviceId(deviceId) {
      await getTierInfoByDeviceId(deviceId).then(res => {
        if (res.code === 0) {
          if (res.data != null) {
            this.tierList = res.data
            if (this.tierList.length !== 0) {
              this.tierList.forEach(item => {
                item.backgroundColor = 'rgb(11,59,103)'
              })
            }
          }
        }
      })
    },
    // 查询当前层的所有区域
    async getAreasByTier(deviceId, floor){
      await getTierInfoByDeviceId(deviceId, floor).then(res => {
        if (res.code === 0 && res.data != null && res.data.length!=0) {
          this.areaList=res.data
          this.areaList.forEach(item=>{
            if(item.realTimeList!=null && item.realTimeList.length!=0){
              item.realTimeList.forEach(item1=>{
                this.areaAlarmList.push(item1)
              })
            }
          })
        }
      })
    },
    // 弹窗关闭事件
    divClose() {
      this.$emit('divClose', this.visible)
    },
    // 左边抽屉关闭事件
    tierDrawerClose() {
      this.tierDrawer = false
    },
    // 右边抽屉关闭事件
    areaDrawerClose() {
      this.areaAlarmDrawer = false
    },
    // 楼层点击事件
    tierClick(item) {
      let tierListCopy = []
      // 还原列表中其它楼层背景颜色
      this.tierList.forEach(tier => {
        if (item.id === tier.id) {
          tier.backgroundColor = 'rgb(26,107,179)'
        } else {
          tier.backgroundColor = 'rgb(11,59,103)'
        }
        tierListCopy.push(tier)
      })
      this.tierList = tierListCopy
      this.areaAlarmList=[]
      this.indoorBg=item.bgImage
      this.getAreasByTier(this.deviceInfo.id,item.ordinal)
    }
  },
  destroyed() {
    this.divClose()
  }
}
</script>

<style scoped>

.title {
  display: inline;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px;
}

.close-btn {
  float: right;
  margin-top: 5px;
  margin-right: 8px;
  font-weight: normal;
  color: #FFFFFF;
}

.close-btn:hover {
  cursor: pointer;
}

.title-line {
  width: 50px;
  height: 2px;
  display: inline-block;
  margin-bottom: 5px;
  border-radius: 15px;
}

.tierDiv {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center
}

.tierDiv:hover {
  background-color: rgb(26, 107, 179) !important;
  cursor: pointer;
}

.asideRight {
  overflow: auto;
  width: 100%;
}

::v-deep .el-drawer {
  background-color: rgb(11, 50, 82);
  border-radius: 0 8px 8px 0;
}

::v-deep .asideRight .el-drawer {
  background-color: rgb(11, 50, 82);
  border-radius: 8px 0 0 8px;
}

::v-deep .asideRight .el-drawer__wrapper {
  width: 20%;
  left: unset;
}

::v-deep .el-drawer__header {
  color: white;
}

::v-deep .el-drawer__body {
  overflow-y: auto;
}


</style>
